import { Link } from "react-router-dom";
import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function RightToBuyPage() {
  return (
    <div data-testid="right-to-buy-page">
      <section className="relative bg-[#111111] py-32 lg:py-40">
        <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1920&q=80')] bg-cover bg-center opacity-15" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-[#d64241] font-semibold text-sm tracking-widest uppercase mb-3 font-body">Special Schemes</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight">
            Right to<br /><span className="text-[#d64241]">Buy</span>
          </h1>
        </div>
      </section>

      <section data-testid="right-to-buy-content" className="py-20 lg:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold text-black tracking-tight mb-4">Overview</h2>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-6 font-body">
                The Right to Buy scheme helps eligible council and housing association tenants in England to buy their home with a discount of up to <strong className="text-black">£127,900</strong> (£96,000 outside London).
              </p>
              <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-8 font-body">
                Find out if you could be eligible, what discount you might get and whether you can afford to buy — and how to take the next steps if you decide to apply.
              </p>

              <h2 className="text-2xl md:text-3xl font-semibold text-black tracking-tight mb-4">Why you might like to buy</h2>
              <div className="space-y-3 mb-8">
                {[
                  "Your home could be a valuable asset for you and your family and an investment for the future.",
                  "Home ownership could give you more freedom to make the changes you want to your home.",
                  "This could be your first step on the property ladder.",
                ].map((item, i) => (
                  <div key={i} className="flex gap-3">
                    <CheckCircle2 className="w-5 h-5 text-[#d64241] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-600 font-body leading-relaxed text-sm">{item}</p>
                  </div>
                ))}
              </div>

              <p className="text-base text-gray-600 leading-relaxed mb-4 font-body">
                Remember, buying your home is a big decision and a commitment that shouldn't be taken lightly. The responsibilities, costs and financial commitments that ownership brings need to be thought about carefully, so you should always get impartial financial and legal advice before buying.
              </p>
              <p className="text-base text-gray-600 leading-relaxed mb-4 font-body">
                But with a bigger discount of up to £96,000 (£127,900 in London) now available, this could be the perfect time to decide if it's the right choice for you.
              </p>
              <p className="text-base text-gray-600 leading-relaxed mb-8 font-body">
                The government's Right to Buy Agent service also offers free and impartial advice on Right to Buy and, if you decide home ownership is the right choice for you, our advisers can help you through the process of buying your home.
              </p>

              <Link to="/contact">
                <Button data-testid="right-to-buy-cta-btn" className="bg-[#d64241] hover:bg-[#b53736] text-white rounded-full px-8 py-6 text-base font-semibold shadow-lg shadow-[#d64241]/25 hover:-translate-y-0.5 transition-all duration-200">
                  Get Expert Advice <ArrowRight className="w-4 h-4 ml-1" />
                </Button>
              </Link>
            </div>
            <div>
              <div className="rounded-2xl overflow-hidden shadow-[0_20px_60px_rgba(0,0,0,0.1)]">
                <img src="https://images.unsplash.com/photo-1560520653-9e0e4c89eb11?w=800&q=80" alt="Right to Buy" className="w-full h-[400px] lg:h-[550px] object-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
